import { APP_SET_PAGE } from "../../constants/app";
import { PAGE_RESEARCH, PAGE_BUILD } from "../../constants/pages";
import * as c from "../../constants/research";
import { GRADE_BEGIN_SUCCESS, GRADE_RETAKE_SUCCESS } from "../../constants/grades";

export const defaultState = {
  sequence: [],
  exercises: [],
  questions: [],
  sequenceIndex: 0,
  selectedPage: "",
  selectedHelp: "",
  isHelpOpen: false
};

const research = (state = defaultState, action) => {
  let selectedPage = state.selectedPage;

  switch (action.type) {
    case c.RESEARCH_LOAD_DATA:
      return {
        ...state,
        sequence: action.sequence,
        exercises: action.exercises,
        questions: action.questions
      };
    case c.RESEARCH_SET_PAGE:
      if (action.page === null || action.page === undefined) {
        return {
          ...state,
          selectedPage: defaultState.selectedPage,
          sequenceIndex: defaultState.sequenceIndex
        };
      } else {
        const pageIndex = state.exercises.findIndex(
          item => item.code === action.page.code
        );
        if (pageIndex > -1) {
          return {
            ...state,
            selectedPage: action.page.code,
            sequenceIndex: state.sequence.indexOf(action.page.code)
          };
        } else {
          return state;
        }
      }
    case c.RESEARCH_OPEN_HELP:
      const sequenceIndex = state.sequence.indexOf(action.code);
      return {
        ...state,
        selectedHelp: action.code,
        isHelpOpen: true,
        sequenceIndex
      };
    case c.RESEARCH_CLOSE_HELP:
      return { ...state, selectedHelp: "", isHelpOpen: false };
    case GRADE_BEGIN_SUCCESS:
      const newQuestions = action.result.responses.map(response => {
        return { exerciseCode: action.code, ...response.question };
      });
      return {
        ...state,
        questions: [...state.questions, ...newQuestions]
      };
    case GRADE_RETAKE_SUCCESS:
      return {
        ...state,
        questions: [
          ...state.questions.filter(q => q.exerciseCode !== action.code),
          ...action.result.responses.map(r => {
            return { exerciseCode: action.code, ...r.question };
          })
        ]
      };
    case APP_SET_PAGE:
      // if the main page changes, unset the research page if it doesn't belong on the main page
      if (state.selectedPage.length > 0) {
        let page = state.exercises.find(
          item => item.code === state.selectedPage
        );
        if (action.page === PAGE_RESEARCH && page.category === "build") {
          selectedPage = "";
        } else if (action.page === PAGE_BUILD && page.category !== "build") {
          selectedPage = "";
        }
        return { ...state, selectedPage };
      } else {
        return state;
      }
    default:
      return state;
  }
};

export default research;
